module.exports = __webpack_public_path__ + "img/bulb@2x.34b44282.png";